import React from "react";
import Footer from "../../components/Footer/Footer";
import PageTop from "../../components/PageTop/PageTop";
import RefundPolicy from "../../components/RefundPolicy/RefundPolicy";
import MainNav from "../../shared/MainNav/MainNav";

export default function Refund() {
  return (
    <>
      <MainNav title="Refund Policy" />
      <PageTop pageTitle="Refun Policy" />
      <RefundPolicy />
      <Footer />
    </>
  );
}
